/**
 * Class is used to hold all the screen labels
 */
export class ScreenLabels {
    // Constants for cancel button
    static CANCEL_BUTTON: string = 'CANCEL';
    // Constants for empty string ''
    static EMPTY_STRING: string = '';
    // Constants for OK
    static OK: string = 'OK';
    // Constants for SAVE
    static SAVE: string = 'SAVE';
    // Constants for YES
    static YES: string = 'YES';
    // Constants for NO
    static NO: string = 'NO';
    // Constants for NA
    static NA: string = 'NA';
    // constant for Allocated
    static ALLOCATED: string = 'Allocated';
    // constant for In Transit
    static IN_TRANSIT: string = 'In Transit';
    // constant for Ground
    static GROUND: string  = 'Ground';
    // constant for A
    static A: string = 'A';
    // constant for F
    static F: string = 'F';
    // constant for G
    static G: string = 'G';
    // Constant for D
    static D: string = 'D';
    // constant for DIO
    static DIO: string = 'DIO';
    // constant for logout warning
    static TIMEOUT_WARNING: string = 'TIMEOUT WARNING';
    // constant for Reset
    static RESET: string = 'RESET';
    // constant for Cancel Reserve
    static CANCEL_RESERVE: string = 'CANCEL RESERVE';
    // Constant for Close
    static CLOSE: string = 'CLOSE';
    static CALCULATE:string ='CALCULATE';
    // Constant for CLEAR;
    static CLEAR: string = 'CLEAR';
    // constant for Available Colors
    static AVAILABLE_COLORS: string = 'Available Colors';
    // constant for Delete
    static DELETE: string = 'DELETE';
    // Constant for Confirm button
    static CONFIRM: string = 'Confirm'
    // Constant for Apply for Credit button
    static APPLY_FOR_CREDIT: string = 'Apply for Credit'
}
